import FastingNonStartedHeader from './FastingNonStartedHeader';

export default FastingNonStartedHeader;
